import React, { useState, useEffect } from 'react'
import '../styles/about.css';
import '../styles/home.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';




function About() {


    const [screenSize, setScreenSize] = useState({
        isLapTop: window.innerWidth > 1100 && window.innerWidth <= 1550,
        isMediumLarge: window.innerWidth > 880 && window.innerWidth <= 1100,
        isMedium: window.innerWidth > 800 && window.innerWidth <= 880,
        isSmallMedium: window.innerWidth > 700 && window.innerWidth <= 800,
        isMobile: window.innerWidth <= 700 && window.innerWidth > 560,

    });

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;

            setScreenSize({
                isLapTop: width > 1100 && width <= 1550,
                isMedium: width > 800 && width <= 880,
                isMobile: width <= 700 && width > 560,
                isMediumLarge: width > 880 && width <= 1100,
                isSmallMedium: width > 700 && width <= 800,

            });
        };

        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const { isMediumLarge, isMedium, isMobile, isExtraSmall, isSmallMedium, isExtraExtraSmall, isLapTop } = screenSize;
    return (
        <div id="about-main" >
            <Helmet>
                <title>About</title>
                <meta name="description" content="Seattle's trusted home remodeler, delivering expert renovations with quality craftsmanship and personalized service. Transform your space today!" />
                <meta name="keywords" content="about us, company, values, team" />
                <meta property="og:title" content="About Us - Alpha Builders" />
                <meta property="og:url" content="https://alphabuilders-wa.com/about" />
                <meta property="og:description" content="Learn more about our company and values." />
            </Helmet>


            <section id="about-s1">
                <div className="logo-cont">

                    <div className='logo-about'>

                        <img src='images/logo-2.png' alt='alpha builders logo' />
                    </div>


                </div>

                <div id="about-line"></div>

                <p>Alpha Builders is a trusted construction and remodeling company serving Western and Central Washington, specializing in high-quality renovations and home improvements. From kitchen and bathroom remodels to flooring, roofing, carpentry, and full-scale renovations, we bring craftsmanship and attention to detail to every project. Whether you're upgrading your home or tackling a new construction project, Alpha Builders delivers reliable, professional service to transform your space with lasting results.</p>
            </section>


            <h2 id='abh2-2' style={{ marginBottom: '10px' }} className="h2-primary">Michael Cubine</h2>
            <p id='absub-2' style={{ marginBottom: '10px' }} className="sub-head">CEO and Founder</p>

            <section id="about-s2">
                <div id='head-shot-cont' className='brass-gradient'>
                    <div style={{ backgroundImage: `url('images/mhs.jpg')`, backgroundSize: 'cover' }}
                        id="michael-headshot">

                    </div>
                </div>



                <div id="abt-s2-description">
                    <h2 id='abh2' style={{ marginBottom: '10px' }} className="h2-primary">Michael Cubine</h2>
                    <p id='absub' style={{ marginBottom: '10px' }} className="sub-head">CEO and Founder</p>
                    <p style={{ color: 'white', lineHeight: '1.5' }}>Michael Cubine is the founder and driving force behind Alpha
                        Builders, a
                        company that reflects
                        his dedication to quality and innovation in the construction industry. With over six years of
                        experience as a contractor, Michael has not only built a thriving business but also established a
                        strong reputation for delivering exceptional results. Before Alpha Builders, he successfully
                        managed Big Ideas Construction, honing his skills in project management, client relations, and hands-on
                        construction work. His expertise spans a wide range of construction projects—over 57 in total—which
                        underscores his passion and commitment to his craft. Michael’s leadership at Alpha Builders is
                        defined by his focus on precision, reliability, and a deep understanding of what it takes to bring
                        each project vision to life.</p>

                </div>
            </section>

            <br />
            <br />
            <br />
            <br />



            <section id='who-we'>


                <div className='intro-description-mobile'>
                    <div className='animate__animated animate__fadeInLeft' id='who-we-1-m'>
                        <h2>WHO ARE WE?</h2>
                        <p>Alpha Builders is a professional remodeling contractor based in Seattle, Washington, providing high-quality renovation services to homeowners across western and central Washington. We specialize in kitchen and bathroom remodels, home additions, and full-scale renovations, delivering reliable craftsmanship and attention to detail. Our team is dedicated to meeting the unique needs of each client. Alpha Builders is your trusted partner for all remodeling needs. </p>

                        <a className='wwb' href='#about-s1'>
                            <button >Learn More</button>
                        </a>
                    </div>

                    <div className='animate__animated animate__fadeInRight' id='who-we-2-m'>
                        <h2>WHAT DO WE DO?</h2>
                        <p>Alpha Builders provides comprehensive remodeling services to homeowners across western and central Washington. We specialize in kitchen and bathroom remodels, home additions, and full-scale renovations, ensuring every project is completed with precision and quality. Our experienced team is committed to delivering tailored solutions that enhance both the functionality and style of your home. Alpha Builders is the go-to choice for all your remodeling projects.</p>

                        <Link className='wwb btn2' to='/services'>
                            <button>Learn More</button>
                        </Link>
                    </div>
                </div>

                <div className='who-we-content'>

                    <div className='animate__animated animate__fadeInLeft' id='who-we-1'>
                        <h2>WHO ARE WE?</h2>
                        <p>Alpha Builders is a professional remodeling contractor based in Seattle, Washington, providing high-quality renovation services to homeowners across western and central Washington. We specialize in kitchen and bathroom remodels, home additions, and full-scale renovations, delivering reliable craftsmanship and attention to detail. Our team is dedicated to meeting the unique needs of each client. Alpha Builders is your trusted partner for all remodeling needs. </p>
                        <a className='wwb' href='#about-s1'>
                            <button >Learn More</button>
                        </a>

                        <div id='who-we-3'>
                            <div className='bp-bg'>
                                <div className='bp-bg-text'>
                                    <h3 className='planwus'>PLAN WITH US</h3>
                                    <h4>Schedule a free and risk free consultation</h4>

                                    <Link to="/contact">
                                        <button>SCHEDULE</button>
                                    </Link>

                                </div>
                                <img id='blue-print' src='images/bp-3.png' alt='blue print' />
                            </div>




                        </div>
                    </div>

                    <div className='animate__animated animate__fadeInRight' id='who-we-2'>
                        <h2>WHAT DO WE DO?</h2>
                        <p>Alpha Builders provides comprehensive remodeling services to homeowners across western and central Washington. We specialize in kitchen and bathroom remodels, home additions, and full-scale renovations, ensuring every project is completed with precision and quality. Our experienced team is committed to delivering tailored solutions that enhance both the functionality and style of your home. Alpha Builders is the go-to choice for all your remodeling projects.</p>

                        <Link className='wwb btn2' to='/services'>
                            <button>Learn More</button>
                        </Link>






                    </div>


                </div>

                {isMediumLarge ? (
                    <img className='whobgimg' src='images/abbg-lm.png' alt='alpha builders home rennovation graphic' />
                ) : isMedium ? (
                    <img className='whobgimg' src='images/abbg-medr.png' alt='alpha builders home rennovation graphic' />
                ) : isMobile ? (
                    <img className='whobgimg' src='images/abbg-mobr.png' alt='alpha builders home rennovation graphic' />
                ) : isSmallMedium ? (
                    <img className='whobgimg' src='images/abbg-sm-2.png' alt='alpha builders home rennovation graphic' />
                ) : isLapTop ? (
                    <img className='whobgimg' src='images/abbg-dark-lap.png' alt='alpha builders home rennovation graphic' />
                ) : (
                    <img className='whobgimg' src='images/abbg-3.png' alt='alpha builders home rennovation graphic' />
                )}
            </section>


            <div id='plan-with-us-mobile'>
                <div className='bp-bg'>
                    <div className='bp-bg-text'>
                        <h3 className='planwus'>PLAN WITH US</h3>
                        <h4>Schedule a free and risk free consultation</h4>

                        <a href='#home-form'>
                            <button>SCHEDULE</button>
                        </a>

                    </div>
                    <img src='images/bp-3.png' alt='blueprint' />
                </div>

            </div>


            <section id='top-section-mobile'>
                <div>

                    <div className='intro-description-mobile'>
                        <div className='animate__animated animate__fadeInLeft' id='who-we-1-m'>
                            <h2>WHO ARE WE?</h2>
                            <p>Alpha Builders is a professional remodeling contractor based in Seattle, Washington, providing high-quality renovation services to homeowners across western and central Washington. We specialize in kitchen and bathroom remodels, home additions, and full-scale renovations, delivering reliable craftsmanship and attention to detail. Our team is dedicated to meeting the unique needs of each client. Alpha Builders is your trusted partner for all remodeling needs. </p>

                            <a className='wwb' href='#about-s1'>
                                <button >Learn More</button>
                            </a>
                        </div>

                        <div className='animate__animated animate__fadeInRight' id='who-we-2-m'>
                            <h2>WHAT DO WE DO?</h2>
                            <p>Alpha Builders provides comprehensive remodeling services to homeowners across western and central Washington. We specialize in kitchen and bathroom remodels, home additions, and full-scale renovations, ensuring every project is completed with precision and quality. Our experienced team is committed to delivering tailored solutions that enhance both the functionality and style of your home. Alpha Builders is the go-to choice for all your remodeling projects.</p>

                            <Link className='wwb btn2' to='/services'>
                                <button>Learn More</button>
                            </Link>
                        </div>
                    </div>

                    <div id='plan-links-phone'>

                        <div id='plan-with-us-phone'>
                            <div className='bp-bg'>
                                <div className='bp-bg-text'>
                                    <h3 className='planwus'>PLAN WITH US</h3>
                                    <h4>Schedule a free and risk free consultation</h4>

                                    <Link to="/contact">
                                        <button>SCHEDULE</button>
                                    </Link>

                                </div>
                                <img src='images/bp-3.png' alt='blueprint' />
                            </div>

                        </div>


                    </div>

                </div>




                <img id='graphic-house' src='images/house-graphic.png' alt='alpha builders remodeling graphic' />
            </section>





        </div>
    )
}

export default About